<template>
  <div class="pdf-zoom" v-if="fit != 'fixed'">
    <a @click.prevent.stop="zoomIn" v-b-tooltip.hover title="Zoom In"><i class="fas fa-plus-circle"></i></a>
    <a @click.prevent.stop="zoomOut" v-b-tooltip.hover title="Zoom Out"><i class="fas fa-minus-circle"></i></a>
    <a @click.prevent.stop="fitWidth" v-b-tooltip.hover title="Fit Width"><i class="fas fa-expand-arrows-alt"></i></a>
    <a @click.prevent.stop="fitAuto" v-b-tooltip.hover title="Auto Fit"><i class="fas fa-compress-arrows-alt"></i></a>
  </div>
</template>

<script>
function setZoom(zoom,el) {

  let transformOrigin = [0,0];
  el = el;
  var p = ["webkit", "moz", "ms", "o"],
        s = "scale(" + zoom + ")",
        oString = (transformOrigin[0] * 100) + "% " + (transformOrigin[1] * 100) + "%";

  for (var i = 0; i < p.length; i++) {
      el.style[p[i] + "Transform"] = s;
      el.style[p[i] + "TransformOrigin"] = oString;
  }

  el.style["transform"] = s;
  el.style["transformOrigin"] = oString;

}

export default {
  name: 'PDFZoom',

  components: {

  },
  data() {
    return {
      zoomVal: 10,
    };
  },
  props: {
    scale: {
      type: Number,
    },
    increment: {
      type: Number,
      default: 0.25,
    },
    fit: {
      type: String,
    }
  },

  computed: {
    isDisabled() {
      return !this.scale;
    },
  },

  methods: {
    zoomIn() {
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$bus.$emit('pdf::pages::visibility::scale',{scale});
    },

    fitWidth() {
      this.$bus.$emit('pdf::pages::visibility::zoom','width');
    },

    fitAuto() {
      this.$bus.$emit('pdf::pages::visibility::zoom', 'auto');

    },

    showVal(a){
      let zoomScale = Number(a)/10;
      $('.pdf-viewer__document .scrolling-page').each(function() {
        setZoom(zoomScale, this)
      });
    }
  },
}
</script>

<style scoped>
.pdf-zoom {
  display: flex;
  flex-wrap: nowrap;
  height: 40px;
  justify-content: space-around;
  width: 160px;
}

.pdf-zoom a {
  border-radius: 5px!important;
  padding: 5px;
  border: 1px solid #d3d3d3;
  font-size: 1.5rem;
  color: #a0a0a0;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}


.pdf-zoom a:hover {
  color: #fff;
  background: #797979;
}

</style>
